/* eslint-disable no-loop-func */
import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import SubMenu from './SubMenu';
import MenuButton from './MenuButton';

export default class MainMenu extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene
   */
  constructor(scene) {
    super(scene);

    this.subMenuX = 0;
    this.menuItems = [];
    this.menuColors = gameData.settings.MENU_COLORS;

    this.subMenu = new SubMenu(scene);
    this.subMenu.x = -300;
    this.subMenu.y = 0;
    this.subMenu.on('SELECTED_ITEM', (objData) => {this.itemSelected(objData);});
    this.subMenu.on('RELEASE_ITEM', this.releaseItem, this);
    this.add(this.subMenu);

    let item;
    let y = 0;
    let waitTime = 0;
    let menuHeight = 0;

    for (let i = 0; i < gameData.settings.MENU_COLORS.length; i++) {
      item = new MenuButton(this.scene, i);
      this.add(item);
      item.y = y;
      item.x = -item.getBounds().width;
      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {this.menuClick(i);});

      ABCyaPhaser.Tweens.addTween(item, 150, { delay: waitTime, x: 0 }, Phaser.Math.Easing.Linear);

      waitTime += 100;
      y = item.y + item.getBounds().height;
      this.menuItems.push(item);
      menuHeight += item.getBounds().height;
    }

    this.subMenu.myRect = { width: gameData.settings.SUBMENU_WIDTH, height: menuHeight };
    this.subMenuX = this.menuItems[0].getBounds().width;
  }

  itemSelected(objData) {
    if (objData.menuNum === gameData.settings.BASE_ITEM_INDEX) { // Special case for base item
      this.emit('CHANGE_BASE_ITEM', objData.subMenuNum);
    }
    else {
      this.emit('SELECTED_ITEM', objData);
    }
  };

  releaseItem() {
    this.emit('RELEASE_ITEM');
  };

  menuClick(ind) {
    const itemIndex = ind;
    if (itemIndex === this.currentMenu) return; // Bail if it's the selected menu

    const soundName = this.menuSoundAlt ? 'menu_1' : 'menu_2';
    this.menuSoundAlt = !this.menuSoundAlt;
    ABCyaPhaser.Audio.playOneShot(soundName, this.scene);

    this.subMenu.changeMenu(itemIndex, this.menuColors[itemIndex]);

    this.currentMenu = itemIndex;

    this.scene.tweens.killTweensOf(this.subMenu);
    this.subMenu.x = 0;
    ABCyaPhaser.Tweens.addTween(this.subMenu, 1220, { x: this.subMenuX, easeParams: [1, .3] }, Phaser.Math.Easing.Elastic.Out);

    this.emit('MENU_CHANGED', this.currentMenu);
  };
}